import React, { useState } from "react";
import { BRAND, IMAGES } from "../../lib/brand";
import { Menu, X, Phone } from "lucide-react";

const links = [
  { label: "Services", href: "#services" },
  { label: "Reviews", href: "#reviews" },
  { label: "Area", href: "#area" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-black/95 backdrop-blur-md border-b-2 border-[#2d2d2d]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-3">
          <img src={IMAGES.logo} alt={BRAND.name} className="h-11 w-11 object-contain" />
          <span className="font-display text-lg leading-none uppercase hidden sm:block">
            Central Alberta<br />
            <span className="text-[#7CB518]">Junk Removal</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-xs uppercase tracking-[0.2em] text-white/70 hover:text-[#7CB518] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid="header-quote-btn"
            className="hidden sm:inline-flex press bg-[#7CB518] text-black font-display uppercase text-sm px-5 py-2 border-2 border-[#7CB518] hard-shadow-white"
          >
            Get Quote
          </a>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-white"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t-2 border-[#2d2d2d] bg-black" data-testid="mobile-menu">
          <div className="flex flex-col px-6 py-4 gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm uppercase tracking-[0.2em] text-white/80 hover:text-[#7CB518]"
              >
                {l.label}
              </a>
            ))}
            <a href={BRAND.phoneHref} className="flex items-center gap-2 text-[#7CB518] font-display text-lg">
              <Phone size={18} /> {BRAND.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
